<template>
    <!-- DESCR：论文详细版权列表页面 -->
    <div class="detailpaperprods-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Paper {{ $route.query.autoid }}</div>
                    <br />
                    <div class="info">
                        This is the detailed information of the paper submitted by {{ $route.query.acronym }}
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="warning" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 论文详细信息 -->
        <el-row :gutter="10" justify="center">
            <el-col :span="24">
                <el-descriptions :column="1" border class="fileshow">
                    <template #title>
                        <h4 class="section">Detailed paper</h4>
                    </template>
                    <el-descriptions-item label="Title:" width="160" label-class-name="my-label">{{ paperinfo.title
                        }}</el-descriptions-item>
                    <el-descriptions-item label="PDF file:" label-class-name="my-label" width="80%"
                        class-name="filebox">
                        <el-icon style="font-size:18px;margin-right:5px;color: #ffb43e;" @click="centerDialogVisible=true">
                            <document />
                        </el-icon>
                        <el-text type="warning" @click="centerDialogVisible=true">paper_{{ $route.query.autoid }}.pdf</el-text>
                    </el-descriptions-item>
                    <el-descriptions-item label="Word file or Zip file:" label-class-name="my-label" class-name="filebox">
                        <template v-if="paperinfo.wordfile != null">
                            <el-icon style="font-size:18px;margin-right:5px;color: #ffb43e;" @click="downloaWord">
                                <document />
                            </el-icon>
                            <el-text type="warning" @click="downloaWord">paper_{{ $route.query.autoid }}.{{wordtype}}</el-text>
                            <el-upload :headers="{ 'token': token }"
                                :action="`https://www.gdstinfo.cn/api/copyright/upload/${paperinfo.pid}`"
                                :show-file-list="false" :on-success="handleFileSuccess" style="display: flex;align-items: center;">
                                <el-icon style="font-size:15px;margin-left:10px;color: #979797;">
                                    <Refresh />
                                </el-icon>
                            </el-upload>
                        </template>
                        <template v-else>
                            <el-upload class="avatar-uploader" :headers="{ 'token': token }"
                                :action="`https://www.gdstinfo.cn/api/copyright/upload/${paperinfo.pid}`"
                                :show-file-list="false" :on-success="handleFileSuccess">
                                <el-icon style="font-size:18px;margin-right:5px;color: #f56c6c;">
                                    <upload />
                                </el-icon>
                                <el-text type="danger">Please upload a Word file or Zip file</el-text>
                            </el-upload>
                        </template>
                    </el-descriptions-item>
                    <el-descriptions-item label="Copyright form:" label-class-name="my-label" class-name="filebox">
                        <template v-if="paperinfo.copyfile != null">
                            <el-icon style="font-size:18px;margin-right:5px;color: #ffb43e;" @click="downloaCopy">
                                <document />
                            </el-icon>
                            <el-text type="warning" @click="downloaCopy">paper_{{ $route.query.autoid
                                }}_copyright.pdf</el-text>
                            <el-upload class="avatar-uploader" :headers="{ 'token': token }"
                                :action="`https://www.gdstinfo.cn/api/copyright/upload/${paperinfo.pid}`"
                                :show-file-list="false" :on-success="handleFileSuccess" style="display: flex;align-items: center;">
                                <el-icon style="font-size:15px;margin-left:10px;color: #979797;">
                                    <Refresh />
                                </el-icon>
                            </el-upload>
                        </template>
                        <template v-else>
                            <el-upload class="avatar-uploader" :headers="{ 'token': token }"
                                :action="`https://www.gdstinfo.cn/api/copyright/upload/${paperinfo.pid}`"
                                :show-file-list="false" :on-success="handleFileSuccess">
                                <el-icon style="font-size:18px;margin-right:5px;color: #f56c6c;">
                                    <upload />
                                </el-icon>
                                <el-text type="danger">Please upload the copyright document</el-text>
                            </el-upload>
                        </template>
                    </el-descriptions-item>
                    <el-descriptions-item label="Types of papers" label-class-name="my-label" v-show="checkPermission([`${$route.query.cid}.publish`])">
                        <el-select v-model="paperinfo.typesid" placeholder="Please select the category of the paper"
                            style="width: 500px;" @change="modifyTypes">
                            <el-option v-for="item in paperTypes" :key="item.id" :label="item.name" :value="item.id"
                                @contextmenu.prevent="deleteTypes(item.id, item.name)">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">{{
                item.id }}</span>
                            </el-option>
                            <template #footer>
                                <el-button v-if="!isAdding" text bg size="small" @click="onAddOption">
                                    Add paper types
                                </el-button>
                                <template v-else>
                                    <el-form :model="types" class="demo-form-inline" label-width="50px"
                                        label-position="left">
                                        <el-form-item>
                                            <template #label>
                                                <el-text size="small">
                                                    Name
                                                </el-text>
                                            </template>
                                            <el-input v-model="types.name" class="option-input"
                                                placeholder="input types name" size="small" style="width:200px" />
                                        </el-form-item>
                                        <el-form-item>
                                            <template #label>
                                                <el-text size="small">
                                                    Weight
                                                </el-text>
                                            </template>
                                            <el-input-number v-model="types.weight" :min="1" :max="99" size="small"
                                                controls-position="right" style="width:200px" />
                                        </el-form-item>
                                    </el-form>
                                    <el-button type="primary" size="small" @click="addTypes">
                                        confirm
                                    </el-button>
                                    <el-button size="small" @click="clear">cancel</el-button>
                                </template>
                            </template>
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item label="Pages" label-class-name="my-label">
                        {{ paperinfo.pagenum }}
                    </el-descriptions-item>
                    <el-descriptions-item label="Time (GMT):" label-class-name="my-label">{{ paperinfo.updatetime }}
                    </el-descriptions-item>
                </el-descriptions>
                <el-table :data="paperinfo.authorList" strip border style="margin-top: 20px;">
                    <el-table-column prop="firstname" label="firstname" width="130" align="center"></el-table-column>
                    <el-table-column prop="lastname" label="last name" width="130" align="center"></el-table-column>
                    <el-table-column prop="email" label="email" align="center" width="200"></el-table-column>
                    <el-table-column prop="country" label="country" width="130" align="center"></el-table-column>
                    <el-table-column prop="affiliation" label="affiliation" align="center"></el-table-column>
                    <el-table-column prop="webpage" label="Web page" width="150" align="center"></el-table-column>
                    <el-table-column label="corresponding?" align="center" width="180">
                        <template #default="scope">
                            <el-checkbox v-model="scope.row.isCorresponding" :checked="scope.row.isCorresponding == 1"
                                disabled></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- 隐藏层 -->
        <!-- 文档预览弹出层 -->
        <div class="office-dia">
            <el-dialog v-model="centerDialogVisible" title="Paper preview" width="70%" center draggable top="5vh">
                <el-scrollbar height="500px" v-loading="loading">
                    <vue-office-pdf ref="pdfView" :src="pdf" @rendered="rendered" class="myoffice" />
                </el-scrollbar>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="printpdf">Print</el-button>
                        <el-button type="primary" @click="download">Download</el-button>
                    </span>
                </template>
            </el-dialog>
        </div>
        <!-- 确认删除类型 -->
        <el-dialog v-model="diadeleteTypes" title="Delete Category" width="500">
            <span>Are you sure you want to delete it：<br><el-text type="danger">{{ curTypes.name }}</el-text></span>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="diadeleteTypes = false">Cancel</el-button>
                    <el-button type="primary" @click="deletePaperTypes">
                        Confirm
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex"
import { Document, Plus, Delete, Download, ArrowLeftBold, Upload, Refresh } from '@element-plus/icons'
import VueOfficePdf from '@vue-office/pdf'
import '@vue-office/docx/lib/index.css'
import printJS from 'print-js'
import { saveAs } from 'file-saver';
import request from "../../network/request"
import checkPermission from "../../utils/checkPermission"
import { ElMessage } from 'element-plus'
import { Icon } from '@vicons/utils'
import shortid from 'shortid';

const route = useRoute()
const store = useStore()


const isAdding = ref(false)
const typesName = ref("")
const types = ref({ name: "", weight: 1 })
const token = store.state.user.token
const diadeleteTypes = ref(false);
const curTypes = ref({});

// 论文详细信息
const paperinfo = ref({})
// 文件预览显示状态
const centerDialogVisible = ref(false)
// pdf文件下载链接
const pdf = ref()
// 加载状态
const loading = ref(true)
// pdf视图
const pdfView = ref(null)
// word类型(doc or docx)
const wordtype = ref("doc")

// 添加新的论文类型
const onAddOption = () => {
    isAdding.value = true
}
const clear = () => {
    typesName.value = ''
    isAdding.value = false
}

// 获取论文详细信息
function getPaperDetail() {
    request.post("/paper/detail", {
        pid: route.query.pid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        paperinfo.value = res.data
        // 获取word的类型
        wordtype.value = paperinfo.value.wordfile?.split('/').pop().split('.').pop(); // 直接从URL提取文件类型
        console.log(wordtype.value);
        pdf.value = paperinfo.value.paperfile
        // 获取论文种类
        getpaperTypes()
    })
}

// 获取论文种类
const paperTypes = ref([])
function getpaperTypes() {
    request.post(`/copyright/papertypes/${paperinfo.value.cid}`).then((res) => {
        if (res.code == 200) {
            paperTypes.value = res.data
        }
    })
}

// 预览pdf加载事件
const rendered = () => {
    loading.value = false
}

//打印PDF
const printpdf = () => {
    printJS(pdf.value)
}

// 下载PDF论文文件
const download = () => {
    saveAs(paperinfo.value.paperfile+"?v="+shortid.generate(), `paper_${paperinfo.value.autoid}.pdf`)
}

// 下载Word论文文件
const downloaWord = () => {
    saveAs(paperinfo.value.wordfile+"?v="+shortid.generate(), `paper_${paperinfo.value.autoid}.${wordtype.value}`)
}

// 下载版权书
const downloaCopy = () => {
    saveAs(paperinfo.value.copyfile+"?v="+shortid.generate(), `paper_${paperinfo.value.autoid}_copyright.pdf`)
}

// 版权书和Word上传
const handleFileSuccess = (response, uploadFile) => {
    ElMessage({ message: 'file uploaded successfully', type: 'success' })
    getPaperDetail()
}

// 新增论文种类
const addTypes = () => {
    request.post(`/copyright/addtypes/${paperinfo.value.cid}`, {
        name: types.value.name,
        weight: types.value.weight
    }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'add successfully',
                type: 'success',
            })
            getpaperTypes()
        } else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}

// 修改论文种类
const modifyTypes = (payload) => {
    request.post(`/copyright/modify/${paperinfo.value.pid}`, { typesid: payload }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'modified successfully',
                type: 'success',
            })
        }
    })
}

// 删除论文种类
const deletePaperTypes = () => {
    request.post(`/copyright/delete/${paperinfo.value.cid}`, { typesid: curTypes.value.typesid }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'delete successfully',
                type: 'success',
            })
            getPaperDetail()
            getpaperTypes()
        }
        diadeleteTypes.value = false
    })
}

// 删除论文类型
const deleteTypes = (typesid, name) => {
    curTypes.value = { typesid: typesid, name: name };
    diadeleteTypes.value = true;
}

onMounted(() => {
    // 获取论文消息
    getPaperDetail()
})
</script>


<style lang="scss">
.detailpaperprods-box {
    padding-bottom: 30px;
    position: relative;

    .office-dia {
        .vue-office-pdf-wrapper {
            padding: 0px !important;
        }
    }

    .section {
        font-weight: 700;
        font-size: 17px;
        padding: 0;
        -webkit-background-clip: text;
        background-clip: text;
        background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 41, 66));
        color: transparent;
    }

    .login-title {
        background: #fde2b72e;
        margin-bottom: 25px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .my-label {
        background-color: #e9f4ff24 !important;
    }

    .el-descriptions__label {
        width: 180px !important;
    }

    .authorbtn {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 50px 0 20px 0;

    }

    .status {
        margin-top: 0px;
    }

    .submit {
        padding-left: 260px;
        width: 100%;

        .el-button {
            width: 300px;
        }
    }

    .reviews {
        margin-bottom: 30px;

        td {
            border: 0 !important;
        }

        .title {
            text-align: center;
            background-color: #93b5c2ba;
            padding: 2px;
            color: #f9f8f8;
        }
    }

    .msg-box {
        white-space: pre-line;
        font-size: 13px;
        padding: 12px;
        background-color: #f5f7fa9c;
        color: #337095db;
    }

    .email-item {
        background-color: #679ac314 !important;
    }

    .arq-box {
        position: absolute;
        right: -15%;
        top: 0%;
        background-color: #b7dffd3b;
        // height: 60px;
        width: 130px;
        padding: 10px;
        border-left: 3px solid #81b4db;
        border-right: 3px solid #81b4db;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
        color: #3a84bd;
        padding-left: 20px;

        div {
            margin-bottom: 5px;
        }
    }

    .fileshow {
        .filebox {
            display: flex;
            align-items: center;

            .el-icon {
                cursor: pointer;
            }

            .el-text {
                cursor: pointer;
            }
        }
    }
}
</style>